import React from 'react';
import { Box, Typography, Card, CardContent, Alert } from '@mui/material';
import { Refresh as RefundIcon, Construction, InfoOutlined } from '@mui/icons-material';

export function RefundsTab() {
  return (
    <Box>
      <Card>
        <CardContent sx={{ textAlign: 'center', py: 8 }}>
          <Construction sx={{ fontSize: 80, color: 'text.secondary', mb: 3 }} />
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            Refund Management
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 600, mx: 'auto' }}>
            Centralized refund management system for cancelled bookings, disputes, and manual refund requests.
            Currently, refunds are processed through the booking cancellation flow.
          </Typography>

          <Alert severity="info" icon={<InfoOutlined />} sx={{ maxWidth: 700, mx: 'auto', textAlign: 'left', mb: 3 }}>
            <Typography variant="body2" gutterBottom>
              <strong>Current Refund Workflow:</strong>
            </Typography>
            <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 0 }}>
              <li>Refunds are automatically processed when bookings are cancelled</li>
              <li>Cancellation fees are applied based on booking policies</li>
              <li>Dispute resolutions can trigger manual refunds</li>
            </Typography>
          </Alert>

          <Alert severity="warning" sx={{ maxWidth: 700, mx: 'auto', textAlign: 'left' }}>
            <Typography variant="body2" gutterBottom>
              <strong>Required for Unified Refund Management:</strong>
            </Typography>
            <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 0 }}>
              <li>GET /api/v1/admin/refunds - List all refunds with status tracking</li>
              <li>POST /api/v1/admin/refunds - Create manual refund</li>
              <li>GET /api/v1/admin/refunds/stats - Refund analytics</li>
            </Typography>
          </Alert>

          <Box sx={{ mt: 4 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Planned Features:
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mt: 2 }}>
              <Card variant="outlined" sx={{ p: 2, minWidth: 200 }}>
                <RefundIcon sx={{ color: 'primary.main', mb: 1 }} />
                <Typography variant="body2" fontWeight="600">Refund History</Typography>
                <Typography variant="caption" color="text.secondary">
                  Complete audit trail of all refunds with reasons
                </Typography>
              </Card>
              <Card variant="outlined" sx={{ p: 2, minWidth: 200 }}>
                <RefundIcon sx={{ color: 'primary.main', mb: 1 }} />
                <Typography variant="body2" fontWeight="600">Manual Refunds</Typography>
                <Typography variant="caption" color="text.secondary">
                  Process refunds outside of cancellation flow
                </Typography>
              </Card>
              <Card variant="outlined" sx={{ p: 2, minWidth: 200 }}>
                <RefundIcon sx={{ color: 'primary.main', mb: 1 }} />
                <Typography variant="body2" fontWeight="600">Partial Refunds</Typography>
                <Typography variant="caption" color="text.secondary">
                  Flexible refund amounts with custom reasons
                </Typography>
              </Card>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
